import React from 'react';
import { string, arrayOf, object, bool } from 'prop-types';
import StackableCardWrapper from '../../../components/library/stacking-collapsible-cards/StackableCardWrapper';
import FilingStatusCard from './FilingStatusCard';

const DiyRefileStatusCard = props => {

    const { id, returnInfo, returnStatii, hideJsonButtons } = props

    const toTitleCase = (str) => {
        // handle casing (this is ugly, I know but if I use css to handle casing, the 'et' 
        // in the french format becomes capilalized, which I don't want)
        return str.replace(/(^|[\s-])\S/g, function (t) { return t.toUpperCase() });
    }

    const clientName = id === 'SPOUSE' ?
        toTitleCase(`${returnInfo.spouseFirstName || ''} ${returnInfo.spouseLastName || ''}`.trim()) :
        toTitleCase(`${returnInfo.primaryFirstName || ''} ${returnInfo.primaryLastName || ''}`.trim())

    var acceptedSubmissionTypes = ['CRA', 'REFILECRA', 'RQ']
    var platformTaxYearCheck = ((returnInfo.taxYear >= 2017 && (!returnInfo.platforms || !returnInfo.platforms.length || returnInfo.platforms[0] === 'ONLINE')));

    if (!returnStatii.some((r) => { return acceptedSubmissionTypes.indexOf(r.submissionType) > -1 })) {
        return null;
    }

    // determine return ids in this set
    let returnIds = [...new Set(returnStatii.filter(r => r.fileContext === id
        && acceptedSubmissionTypes.indexOf(r.submissionType) > -1
        && platformTaxYearCheck
    ).map((item) => item.returnId))]

    return (
        <StackableCardWrapper className='card-filing-status'>
            {returnIds.sort((a, b) => a.returnId - b.returnId).map((returnId, returnIndex, a) => (
                <FilingStatusCard filer={id} clientName={clientName}
                    hideJsonButtons={hideJsonButtons}
                    returnStatii={returnStatii.filter(r => acceptedSubmissionTypes.includes(r.submissionType) && r.fileContext === id && r.returnId === returnId)}
                    isRefile={a.length - 1 !== returnIndex}
                    refileIndex={a.length - returnIndex}
                    isCollapsed={returnIndex !== 0} />
            ))}
        </StackableCardWrapper>
    )
}

DiyRefileStatusCard.propTypes = {
    id: string,
    returnInfo: object,
    returnStatii: arrayOf(object),
    hideJsonButtons: bool
}

export default DiyRefileStatusCard